import { Box, Grid } from '@mui/material';
import React, { useState } from 'react';
// import Button from './Button';
import Link from './Link';
import { Link as Rlink } from "react-router-dom";
import { useMediaQuery } from '@mui/material';

const ProductCard = props => {
  const isMobile = useMediaQuery('(max-width: 600px)');
  // const [visible, setVisible] = useState(true);
  const { id, image, title, detail, button, link, comingSoon, googleStore, appleStore } = props.data;
  let direct = true;
  if (props.index % 2 === 0) {
    direct = false;
  } else {
    direct = true;
  }
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" className="product-card m-tb-10" style={{ overflow: id === 'platform' && isMobile? 'hidden': 'inherit' }}>
      {direct && (
        <>
          <Grid item lg={6}>
            <Box component="img" src={image} sx={{ width: '80%', marginLeft: 2, transform: id === 'platform' && isMobile? 'scale(1.8)': 'scale(1)' }}></Box>
          </Grid>
          <Grid item lg={6} sx={{ textAlign: 'left' }}>
            {/* <Button className="product-button m-tb-10 no-cursor" title={button} /> */}
            <Box className="t-p card-title-font m-tb-10"> {button} </Box>
            <Box className="t-p card-sub-title-font h5 m-tb-10"> {title} </Box>
            <Box className="t-p card-detail-font m-tb-10"> {detail} </Box>
            {/* {button === 'Game' || button === 'Platform for games' ? ( */}
              <Box
                // onMouseEnter={() => {
                //   if (button !== 'Game' && button !== 'Platform for games') setVisible(false);
                // }}
                // onMouseLeave={() => {
                //   if (button !== 'Game' && button !== 'Platform for games') setVisible(true);
                // }}
                sx={{ display: 'flex', width: 'fit-content' }}
                style={{gap: googleStore? "10px": "0px", width: "100%" }}
              >
                {googleStore && <Rlink to = {googleStore.link} target="_blank" rel="noopener noreferrer"><Box component="img" src = {googleStore.image} className="store-btn full-width" /></Rlink>}
                {appleStore && <Rlink to = {appleStore.link} ><Box component="img" src = {appleStore.image} className="store-btn full-width" /></Rlink>}
                {!comingSoon && link && <Link href={link} isReadMore={true} className="t-o no-line" title="Read more" icon={true} status="active" />}
                {comingSoon && (
                  <Box className="t-o no-line ext-link" sx={{ cursor: 'pointer' }}>
                    Coming soon
                  </Box>
                )}
              </Box>
            {/* ) : (
               <></>
             )} */}
          </Grid>
        </>
      )}
      {!direct && (
        <>
          <Grid item lg={6} sx={{ textAlign: 'left' }}>
            {/* <Button className="product-button m-tb-10 no-cursor" title={button} /> */}
            <Box className="t-p card-title-font m-tb-10"> {button} </Box>
            <Box className="t-p card-sub-title-font h5 m-tb-10"> {title} </Box>
            <Box className="t-p card-detail-font m-tb-10"> {detail} </Box>
            {/* {button === 'Game' || button === 'Platform for games' ? ( */}
              <Box
                // onMouseEnter={() => {
                //   if (button !== 'Game' && button !== 'Platform for games') setVisible(false);
                // }}
                // onMouseLeave={() => {
                //   if (button !== 'Game' && button !== 'Platform for games') setVisible(true);
                // }}
                sx={{ display: 'flex', width: 'fit-content' }}
                style={{gap: googleStore? "10px": "0px", width: "100%" }}
              >
                {googleStore && <Rlink to = {googleStore.link} target="_blank" rel="noopener noreferrer"><Box component="img" src = {googleStore.image} className="store-btn full-width" /></Rlink>}
                {appleStore && <Rlink to = {appleStore.link}><Box component="img" src = {appleStore.image} target="_blank" className="store-btn full-width" /></Rlink>}
                {!comingSoon && link && <Link href={link} isReadMore={true} className="t-o no-line" title="Read more" icon={true} status="active" />}
                {comingSoon && (
                  <Box className="t-o no-line ext-link" sx={{ cursor: 'pointer' }}>
                    Coming soon
                  </Box>
                )}
              </Box>
            {/* ) : (
              <></>
            )} */}
          </Grid>
          <Grid item lg={6}>
            <Box component="img" src={image} sx={{ width: '80%', marginLeft: 2 }}></Box>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ProductCard;
